import { Card, Col, Modal, Row } from 'antd';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { errorCatch, JSXMap, Model, POST, updateInArray, useAuth } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import User from '../../../components/User';
import AdminUserUpdate from '../../forms/AdminUserUpdate';

var _ = require('lodash');

const useStyles = createUseStyles({
	item: {
		padding: "5px 10px",
		display: "flex",
		cursor: "pointer",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
})

export default function Admin(props) {
	const classes = useStyles();
	const auth = useAuth();

	const filters = () => [
		{
			label: "Идентификатор",
			name: "ID",
			sort: true,
			filter: true,
		},
		{
			name: "lastname",
			sort: true,
			filter: true,
		},
		{
			name: "firstname",
			sort: true,
			filter: true,
		},
		{
			name: "patronymic",
			sort: true,
			filter: true,
		},
		{
			name: "email",
			sort: true,
			filter: true,
		},
		{
			label: "Телефон",
			name: "phone",
			sort: true,
			filter: true,
		},
		{
			name: "gender",
			sort: true,
			filter: true,
			display: (o) => o.name,
		},
		{
			label: "Дата регистрации",
			name: "сreatedAt",
			type: "date",
			sort: true,
			filter: true,
		},
		{
			label: "Псевдоним",
			name: "aliase",
			filter: true,
			sort: true,
		}
	];

	const render = (item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) =>
	(<div key={item.ID || idx} style={{ width: "100%" }}>
		<div className={classes.item}>
			<div style={{ flex: "auto" }}>
				<User item={item} />
			</div>
		</div>
	</div>)

	return (
		<Row gutter={[5, 5]} className="filtered-footer">
			<Col span={24}>
				<Card size="small" bordered={false} className={classes.cardSmall}>
					<CollectionServer
						auth={auth}
						name={"User"}
						source={"/api/admin/users"}
						filters={filters}
						size={"small"}
						mode={"list"}
						title="Пользователи"
						render={render}
						modelActions={(item) => {
							return [
								{
									title: "Изменить",
									titles: {
										subheader: <div style={{ paddingBottom: "15px" }}><User item={item} /></div>
									},
									object: item,
									form: AdminUserUpdate,
									action: (values, unlock, close, { collection, setCollection }) => {
										let o = { ...values, ID: item.ID }//, email: values?.email?.replace(/\s/g, '') }
										POST(auth, "/api/admin-update-user", o,
											({ data }) => {
												setCollection(updateInArray(collection, data));
												close();
											}, (err) => errorCatch(err, unlock)
										);
									},
									// action: (values, unlock, close, { collection, setCollection }) => {
									//     // POST(auth, '/api/fed/admin/popolneniescheta', { ...values },
									//     //     ({ data, account }) => {
									//     //         let acc = item.akkauntiPolzovateleiPolzovatel.map(e=>{
									//     //             if(e.akkaunt.ID === account.ID){
									//     //                 return {...e, akkaunt: account};
									//     //             } else {
									//     //                 return e
									//     //             }
									//     //         });
									//     //         setCollection(updateInArray(collection, {
									//     //             ...item,
									//     //             akkauntiPolzovateleiPolzovatel: acc
									//     //         }));
									//     //         close();
									//     //     },
									//     //     (err) => errorCatch(err, unlock)
									//     // );
									// },
								},
							]
						}}
					/>
				</Card>
			</Col>
		</Row>
	);
}
